import { cloneDeep, set } from "lodash";
import store from "../../../../store";
import i18n from "../../../../Utils/i18next/i18next";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { NotificationManager } from "react-notifications";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { secretReducer } = store.getState();
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    uuid,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  let payload;

  if (!update) {
    data.status = secretReducer?.availableStatuses.find(
      (el) => !!el.isSelected,
    );

    const res = await GlobalAuthFetch({
      path: `/secret`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/secret/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();

  props.handleHide();
};

export const onValidate = (values, props) => {
  const { update } = props;
  const errorsStep0 = {};
  const errorsStep1 = {};

  if (!values.client) {
    errorsStep0.client = t("global:secret.errors.client");
  }
  if (!values.clientRepresentative) {
    errorsStep0.clientRepresentative = t(
      "global:secret.errors.clientRepresentative",
    );
  }
  if (!values.customerServiceRepresentative) {
    errorsStep0.customerServiceRepresentative = t(
      "global:secret.errors.customerServiceRepresentative",
    );
  }

  if (!values.participants || values.participants?.length < 1) {
    errorsStep1.participants = t("global:secret.errors.participants");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }
  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }

  return { ...errorsStep0, ...errorsStep1 };
};
